import React, { FC } from "react";
import dynamic from "next/dynamic";

const LoginContainer = dynamic(() => import("containers/Login/Login"), { ssr: false });

const LoginPage: FC = () => {
  return <LoginContainer />;
};

export default LoginPage;
